import React from "react";
import { Grid, TextField, Typography, MenuItem } from "@mui/material";

const PersonalInfo = ({ formData, handleInputChange }) => {
  return (
    <>
      <Grid item xs={12} sm={6}>
        <TextField
          label="Prénom"
          name="prenom"
          value={formData.prenom}
          onChange={handleInputChange}
          required
          fullWidth
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          label="Nom"
          name="nom"
          value={formData.nom}
          onChange={handleInputChange}
          required
          fullWidth
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          label="Âge"
          name="age"
          type="number"
          value={formData.age}
          onChange={handleInputChange}
          required
          fullWidth
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          label="Taille"
          name="taille"
          type="number"
          value={formData.taille}
          onChange={handleInputChange}
          required
          fullWidth
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <Typography
          variant="body2"
          color="textSecondary"
          style={{ marginBottom: "4px", fontStyle: "italic" }}
        >
          Date de naissance
        </Typography>
        <TextField
          name="datedenaissance"
          type="date"
          value={formData.datedenaissance}
          onChange={handleInputChange}
          required
          fullWidth
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          label="Poids Actuel (kg)"
          name="poidsActuel"
          type="number"
          value={formData.poidsActuel}
          onChange={handleInputChange}
          required
          fullWidth
        />
      </Grid>
      {/* New Gender Field */}
      <Grid item xs={12} sm={6}>
        <TextField
          label="Genre"
          name="gender"
          select
          value={formData.gender || ""}
          onChange={handleInputChange}
          fullWidth
          helperText="Sélectionnez votre genre (optionnel)"
        >
          <MenuItem value="">Non précisé</MenuItem>
          <MenuItem value="male">Homme</MenuItem>
          <MenuItem value="female">Femme</MenuItem>
          <MenuItem value="other">Autre</MenuItem>
        </TextField>
      </Grid>
    </>
  );
};

export default PersonalInfo;
